export default {
  title: window.location.hostname.includes("ari-ik") ?  'Arı-ik' : window.location.hostname.includes("trwturkiye") ?  'TrwTeşvik' : "TeşvikMaster"
};
